import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Betalingsmetoder',
  payment_options: {
    [PaymentMethod.Card]: 'Kreditkort',
  },
};
